import template from './location.all.html';
import controller from './location.all.controller';
import './location.all.scss';

let locationallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template,
  controller
};

export default locationallComponent;


// WEBPACK FOOTER //
// ./client/app/components/location/all/location.all.component.js